export enum GpSubscriptionProductType {
  ADD_ON = 'addon',
  BASE_SUBSCRIPTION = 'baseSubscription'
}

export const gpSubscriptionProductTypeFilterName: Record<GpSubscriptionProductType, string> = {
  [GpSubscriptionProductType.ADD_ON]: 'Add-On',
  [GpSubscriptionProductType.BASE_SUBSCRIPTION]: 'Subscription'
};
